'use strict';

function getUTMParameters() {
    return {
        utm_source: sessionStorage.getItem('utm_source') || '',
        utm_medium: sessionStorage.getItem('utm_medium') || '',
        utm_campaign: sessionStorage.getItem('utm_campaign') || '',
        utm_content: sessionStorage.getItem('utm_content') || '',
        utm_term: sessionStorage.getItem('utm_term') || ''
    };
}

module.exports = {
    init: function () {
        var params = new URLSearchParams(window.location.search);
        var utmKeys = [
            'utm_source',
            'utm_medium',
            'utm_campaign',
            'utm_content',
            'utm_term'
        ];

        for (var i = 0; i < utmKeys.length; i++) {
            var key = utmKeys[i];
            var value = params.get(key);

            if (value && value.length <= 500) {
                sessionStorage.setItem(key, value);
            }
        }
    },

    getUTMParameters: getUTMParameters
};